// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.alert-wrapper {
  display: grid;
  grid-template-columns: 40px 1fr 32px;
  align-items: center;
  width: 78.1rem;
  margin-bottom: 2%;
  background-color: #E8E8FF;
  border-radius: 8px;
  padding: 0.75rem 0.25rem 0.75rem 0.75rem;
  box-shadow: rgba(0, 0, 0, 0.04) 0px 3px 5px;
  column-gap: 2px;
  width: 100%;
}
.alert-wrapper * {
  color: #3D3DB8;
  font-size: 16px;
  margin-top: 1px;
}
.alert-wrapper h2 {
  font-weight: 600;
}
.alert-wrapper p {
  margin-top: -9px;
}
.alert-wrapper collab-comp-img-generator ::ng-deep .icon-Warning:before {
  font-weight: 700;
  color: #3D3DB8;
}
.alert-wrapper .close-icon__button {
  background: none;
  padding: 0;
  margin: 0;
  border: none;
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/warning-alert-wrapper/warning-alert-wrapper.component.scss"],"names":[],"mappings":"AAGA;EACI,aAAA;EACA,oCAAA;EACA,mBAAA;EACA,cAAA;EACA,iBAAA;EACA,yBARe;EASf,kBAAA;EACA,wCAAA;EACA,2CAAA;EACA,eAAA;EACA,WAAA;AAFJ;AAII;EACI,cAjBc;EAkBd,eAAA;EACA,eAAA;AAFR;AAKI;EACI,gBAAA;AAHR;AAMI;EACI,gBAAA;AAJR;AAOI;EACI,gBAAA;EACA,cAhCc;AA2BtB;AASI;EACI,gBAAA;EACA,UAAA;EACA,SAAA;EACA,YAAA;EACA,eAAA;AAPR","sourcesContent":["$alert-warning-color: #3D3DB8;\n$alert-warning-bg: #E8E8FF;\n\n.alert-wrapper {\n    display: grid;\n    grid-template-columns: 40px 1fr 32px;\n    align-items: center;\n    width: 78.1rem;\n    margin-bottom: 2%;\n    background-color: $alert-warning-bg;\n    border-radius: 8px;\n    padding: 0.75rem .25rem 0.75rem 0.75rem;\n    box-shadow: rgba(0, 0, 0, 0.04) 0px 3px 5px;\n    column-gap: 2px;\n    width: 100%;\n\n    * {\n        color: $alert-warning-color;\n        font-size: 16px;\n        margin-top: 1px;\n    }\n\n    h2 {\n        font-weight: 600;\n    }\n\n    p {\n        margin-top: -9px;\n    }\n\n    collab-comp-img-generator ::ng-deep .icon-Warning:before {\n        font-weight: 700;\n        color: $alert-warning-color;\n\n    }\n\n    .close-icon__button {\n        background: none;\n        padding: 0;\n        margin: 0;\n        border: none;\n        cursor: pointer;\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
